import * as React from "react";

interface SupportIconProps {
  size?: string | number;
}

function SupportIcon(props: SupportIconProps) {
  const { size } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "34"}
      height={size ?? "34"}
      viewBox="0 0 34 44"
    >
      <g id="Group_1" data-name="Group 1" transform="translate(-200 -254)">
        <g id="Ellipse_1" transform="translate(200 255)" fill="#fff" stroke="#000" strokeWidth="2">
          <circle cx="17" cy="17" r="17" stroke="none" />
          <circle cx="17" cy="17" r="16.5" fill="none" />
        </g>
        <text
          id="_"
          transform="translate(211 254)"
          fill="#000"
          fontSize="29"
          fontFamily="MyanmarMN, Myanmar MN"
        >
          <tspan x="0" y="28">
            ?
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SupportIcon;
